import { toRefs, reactive, watch, computed } from "vue"
import mediaService from "./mediaService"

import firebaseService from "./firebaseService"
const firebase = firebaseService()
import customerService from "./customerService"
import { resolveDeliveryOptions, resolvePaymentOptions } from "oido-data-structures"



const unsubscribeHandles = []

async function teardown() {
    for (let unsubscribeHandle of unsubscribeHandles) {
        await unsubscribeHandle()
    }
    //empty it
    unsubscribeHandles.length = 0
    state.company = {}
    state.companyPictureUrl = null
}
const state = reactive({
    initialized: false,
    initializing: false,
    error: null,
    company: {},
    companyPictureUrl: null,
    pointofsaleId: null
})

async function checkCompanySlug(slug) {

    let slugDoc = await firebase
        .firestore()
        .collection("slugs")
        .doc(slug)
        .get()
    if (slugDoc.exists) {
        let data = slugDoc.data()
        if (data.companyId) {
            return data.companyId
        }
    }
    return null
}

async function checkCustomDomain(customDomain) {

    let doc = await firebase
        .firestore()
        .collection("custom-domains")
        .doc(customDomain)
        .get()

    if (doc.exists) {
        let data = doc.data()
        if (data.companyId) {
            return data.companyId
        }
    }
    return null
}

async function loadCompany(companyId, pointofsaleId) {
    if (state.company && state.company.id == companyId) {
        return
    }
    teardown()
    let companyUnsubscribeHandle = firebase
        .firestore()
        .collection("publicCompanyInfos")
        .doc(companyId)
        .onSnapshot(async (snapshot) => {
            let data = snapshot.data()
            if (data && snapshot.id) {
                data.id = snapshot.id
                state.company = data
                state.pointofsaleId = pointofsaleId ? pointofsaleId : state.company.defaultPointofsaleId


                let imageUrl = null
                if (state.company.logoImage) {
                    imageUrl = await mediaService.getMediaUrl(state.company.logoImage)
                }
                if (!imageUrl && state.company.picture) {
                    imageUrl = await mediaService.getMediaUrl(state.company.picture)
                }
                state.companyPictureUrl = imageUrl
                state.logoImageUrl = imageUrl

            } else {
                state.company = null
                state.pointofsaleId = null
                state.companyPictureUrl = null
            }

        })
    unsubscribeHandles.push(companyUnsubscribeHandle)
}

function getProductById(productId) {
    if (!state.company || !state.company.products) {
        return null
    }
    for (let product of state.company.products) {
        if (product.id == productId) {
            return product
        }
    }
    return null
}
function getPointofsaleById(pointofsaleId) {

    if (!state.company || !state.company.pointsofsale) {
        return null
    }
    for (let pointofsale of state.company.pointsofsale) {
        if (pointofsale.id == pointofsaleId) {
            return pointofsale
        }
    }
    return null
}
function getTaxForProduct(productId) {
    let product = getProductById(productId)
    if (!product) {

        console.log('getTaxForProduct productNotfound', productId)
        return 0
    }
    if (!state.company || !state.company.vat) {
        return 0
    }

    if (product.vatRate && state.company.vatRates && state.company.vatRates.length > 0) {
        for (let rate of state.company.vatRates) {
            if (product.vatRate == rate.id) {
                return rate.rate
            }
        }
    }

    return state.company.vat
}
const activePointofsale = computed(() => {
    let pos = null
    if (state.pointofsaleId) {
        pos = getPointofsaleById(state.pointofsaleId)
    }
    if (!pos && state.company.defaultPointofsaleId) {
        pos = getPointofsaleById(state.company.defaultPointofsaleId)
    }
    if (!pos && state.company.pointsofsale && state.company.pointsofsale.length > 0) {
        pos = state.company.pointsofsale[0]
    }

    //a logged in customer can override the delivery and the payment options of the zone
    //for itself. doing it here means every consumer (checkout, cart defaults, order
    //calculator) sees the same options without knowing about customers at all. the server
    //re-checks the same rules with the same helpers when the order comes in
    let customer = customerService.customer && customerService.customer.value ? customerService.customer.value : null
    if (pos && customer) {
        let resolved = {
            ...resolveDeliveryOptions(pos, customer),
            ...resolvePaymentOptions(pos, customer),
        }
        let changed = Object.keys(resolved).some((key) => resolved[key] !== Boolean(pos[key]))
        if (changed) {
            pos = { ...pos, ...resolved }
        }
    }

    return pos
})

const productsPerCategory = computed(() => {
    let map = {}
    if (state.company && state.company.products) {
        for (let product of state.company.products) {
            if (product.hidden) {
                continue
            }
            
            if (activePointofsale.value && activePointofsale.value.hideProductsWithoutStock) {                
                if (product.numberOfItemsInStock !== null && product.numberOfItemsInStock !== undefined && product.numberOfItemsInStock <= 0) {            
                    continue
                }
            }
            
            if (!map[product.categoryId]) {
                map[product.categoryId] = []
            }
            map[product.categoryId].push(product)
        }
    }
    return map
})

const visibleCategoryIds = computed(() => {
    if (!visibleCategories.value) {
        return []
    }
    let ids = []
    let getIds = (category) => {
        if (!category) {
            return []
        }
        let ids = []
        ids.push(category.id)

        if (category.children) {
            for (let child of category.children) {
                ids = ids.concat(getIds(child))
            }
        }
        return ids
    }

    for (let category of visibleCategories.value) {
        ids = ids.concat(getIds(category))
    }
    return ids
})


const visibleCategories = computed(() => {

    let visibleCategories = []
    if (!activePointofsale.value) {
        return
    }
    let rule = activePointofsale.value.categoryVisibilityRule || "all"
    let config = activePointofsale.value.categoryVisibilityConfig || []

    //if the customer has its own visibility settings overwrite the zone Settings
    // !! always overwrite the rule AND the config
    if (
        customerService.customer &&
        customerService.customer.value &&
        customerService.customer.value.categoryVisibilityRule
    ) {
        rule = customerService.customer.value.categoryVisibilityRule
        config = customerService.customer.value.categoryVisibilityConfig || []
    }

    let getVisibleCats = (category) => {

        if (category.children && category.children.length > 0) {
            let visibleKids = []
            for (let child of category.children) {

                let visibleChild = getVisibleCats(child)
                if (!visibleChild) {
                    continue
                }
                visibleKids.push(visibleChild)
            }
            category.children = visibleKids
        }

        let numberOfPRoducts = productsPerCategory.value && productsPerCategory.value[category.id] ? productsPerCategory.value[category.id].length : 0
        let categoryOrOneOfItsKidsHasAtLeastOneVisibleProduct = (category.children && category.children.length > 0) || numberOfPRoducts > 0

        let shouldbeAdded =
            categoryOrOneOfItsKidsHasAtLeastOneVisibleProduct &&
            (
                (rule == "all") ||
                (rule == "only" && config.includes(category.id)) ||
                (rule == "except" && !config.includes(category.id))
            )

        return shouldbeAdded ? category : null
    }

    console.log('state.company', state.company)
    for (let category of state.company.categories) {
        let cat = getVisibleCats(JSON.parse(JSON.stringify(category)))
        if (cat) {
            visibleCategories.push(cat)
        }
    }
    return visibleCategories
})


//the time table / opening hours resolution lives in the OrderCalculator
//(oido-data-structures) — use typedSystem.orderCalculator.value.getTimeTableHoursForDay(...)


if (!state.initialized && !state.initializing) {
    state.initializing = true
    state.initialized = true
    state.initializing = false
}
export default {
    ...toRefs(state),
    loadCompany,
    getProductById,
    getPointofsaleById,
    getTaxForProduct,
    activePointofsale,
    checkCompanySlug,
    visibleCategories,
    visibleCategoryIds,
    checkCustomDomain,
    productsPerCategory
}

